import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {SequencesResponse} from '../model/responses/sequences-response';
import {SequenceFilters} from '../model/filters/sequence-filters';
import {SequenceSubscriptionPersistRequest} from '../model/requests/sequence-subscription-persist-request';
import {Sequence} from '../model/sequence';
import {SequenceSubscriptionsResponse} from '../model/responses/sequence-subscriptions-response';
import {DeleteResponse} from '../model/responses/delete-response';
import {DeletesResponse} from '../model/responses/deletes-response';
import {SequencePersistRequest} from '../model/requests/sequence-persist-request';

@Injectable({
  providedIn: 'root'
})
export class SequencesService {

  private readonly sequencesURL: string;

  constructor(private http: HttpClient) {
    this.sequencesURL = '/catalog/sequences';
  }

  public createSequence(sequence: SequencePersistRequest) {
    let url: string = `${this.sequencesURL}/create`;
    return this.http.post<any>(url, sequence);
  }

  public deleteSequence(uuid: string): Observable<DeleteResponse> {
    let url: string = `${this.sequencesURL}/${uuid}`;
    return this.http.delete<DeleteResponse>(url);
  }

  public deleteSequences(uuids: { uuid: string }[]): Observable<DeletesResponse> {
    let url: string = `${this.sequencesURL}/delete`;
    return this.http.post<DeletesResponse>(url, uuids);
  }

  public downloadSequenceConfig(sequenceUuid: string): Observable<any> {
    return this.http.get<any>(`${this.sequencesURL}/${sequenceUuid}/download`);
  }

  public getSequence(sequenceUuid: string): Observable<{ sequence: Sequence }> {
    return this.http.get<{ sequence: Sequence }>(`${this.sequencesURL}/${sequenceUuid}`);
  }

  public getSequences(offset?: number, limit?: number, filters?: any): Observable<SequencesResponse> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = filters ?? new SequenceFilters();
    return this.http.post<SequencesResponse>(this.sequencesURL, body, options);
  }

  public getSequenceSubscriptions(sequenceUuid: string): Observable<SequenceSubscriptionsResponse> {
    const url: string = `${this.sequencesURL}/${sequenceUuid}/subscriptions`;
    return this.http.get<SequenceSubscriptionsResponse>(url);
  }

  public updateSequence(sequence: SequencePersistRequest) {
    let url: string = `${this.sequencesURL}/${sequence.uuid}`;
    return this.http.put<any>(url, sequence);
  }

  public updateSequenceSubscriptions(sequenceUuid: string, newEmails: string[], removedEmails: string[]) {
    const url: string = `${this.sequencesURL}/${sequenceUuid}/subscriptions`;
    const request: SequenceSubscriptionPersistRequest = new SequenceSubscriptionPersistRequest(newEmails, removedEmails);
    return this.http.put(url, request);
  }

  public restartSequence(sequenceUuid: string) {
    let url: string = `${this.sequencesURL}/${sequenceUuid}/restart`;
    return this.http.post<any>(url, null, HttpUtils.buildOptions(null));
  }

  public executeSequence(sequenceUuid: string): Observable<any> {
    let url: string = `${this.sequencesURL}/${sequenceUuid}/execute`;
    return this.http.post<any>(url, {});
  }
}
